import { render, staticRenderFns } from "./ResultKcbAuthPop.vue?vue&type=template&id=f051f548&scoped=true&"
import script from "./ResultKcbAuthPop.vue?vue&type=script&lang=js&"
export * from "./ResultKcbAuthPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f051f548",
  null
  
)

export default component.exports